import React from 'react';
import PropTypes from 'prop-types';

import { LRS_ACTIONS, LRS_OBJECT_TYPES } from '@techchange/components';

import { RESOURCE_TYPES } from '../../../../constants';
import RuleEditorForm from '../../RuleEditorForm';

const propTypes = {

	/**
	 * The resource.
	 */
	resource: PropTypes.shape({

		/**
		 * The unique ID of the resource.
		 */
		id: PropTypes.string.isRequired,

		/**
		 * The resource type.
		 */
		type: PropTypes.oneOf([
			RESOURCE_TYPES.FORM, RESOURCE_TYPES.POLL
		]).isRequired,

		/*
		 * The resource title.
		 */
		title: PropTypes.string.isRequired,

		/**
		 * The resource data.
		 */
		data: PropTypes.shape({

			/**
			 * The id of the associated form.
			 */
			form_id: PropTypes.string.isRequired,

		}).isRequired,

	}).isRequired,

	/**
	 * The rule for the resource.
	 */
	rule: PropTypes.shape({

		/**
		 * The condition for the rule.
		 */
		condition: PropTypes.shape({

			/**
			 * The list of subconditions for the condition.
			 */
			subconditions: PropTypes.arrayOf(PropTypes.shape({

				/**
				 * The subcondition ID.
				 */
				id: PropTypes.string,

			})),

		}),

	}),

	/**
	 * The parent resource.
	 */
	parent: PropTypes.shape({

		/**
		 * The parent resource ID.
		 */
		id: PropTypes.string.isRequired,

	}).isRequired,

	/**
	 * The current user's ID.
	 */
	userId: PropTypes.string.isRequired,

	/**
	 * Callback function to handle saving the completion rule.
	 */
	onSave: PropTypes.func.isRequired,

	/**
	 * Callback function to handle cancelling the editor for the completion rule.
	 */
	onCancel: PropTypes.func.isRequired,

};

const RuleEditor = (props) => {

	const { id, type, title, data } = props.resource;

	// Defines the list of possible completion requirements,
	// i.e. subconditions, for the completion rule.
	const initialValues = [{
		active: false,
		// Choose a default action
		action: LRS_ACTIONS.MARKED_COMPLETE,
		// First, a subcondition related to the resource itself
		object_type: type,
		object_id: id,
		object_title: title,
		parent_object_type: null,
		parent_object_id: null,
		parent_object_title: null,
	}, {
		active: false,
		// Choose a default action
		action: LRS_ACTIONS.CREATED,
		// Second, a subcondition related to form entires for the associated form
		object_type: LRS_OBJECT_TYPES.FORM_ENTRY,
		object_id: null,
		object_title: null,
		parent_object_type: type,
		parent_object_id: data.form_id,
		parent_object_title: title,
	}];

	return (
		<RuleEditorForm
			initialValues={initialValues}
			overrideActionOptions
			{...props} />
	);

};

RuleEditor.propTypes = propTypes;

export default RuleEditor;
